import { environment as staging } from './environment.staging';

// stage1 shares staging's Firebase project and Auth0 client; only its backends differ.
export const environment = {
  ...staging,
  vulcan: {
    url: 'https://jxo3rvjzla.execute-api.us-east-1.amazonaws.com/prod/',
  },
  botConfig: {
    ...staging.botConfig,
    url: 'https://6m3djs755a.execute-api.us-east-1.amazonaws.com/stage1/bot-configuration/',
  },
  dumbledore: {
    url: 'https://dumbledore-stage1.testenv.carlabs-x.com/',
  },
  bach: {
    url: 'https://bach-stage1.testenv.carlabs-x.com/',
  },
  analyticsWebSocket: {
    url: 'wss://pok2qbgrnd.execute-api.us-east-1.amazonaws.com/stage1/',
  },
  platformApi: {
    url: 'https://platformapi-stage1.testenv.carlabs-x.com',
  },
  // Must stay listed in the Auth0 application's Allowed Callback URLs.
  authSecrets: {
    ...staging.authSecrets,
    loginUrl: 'https://serviceai.stage1.testenv.impel.io/login',
  },
};
